import { InjectionToken } from "@angular/core";
import { ILicenseRestClient } from "./i-license-rest.client";

export const licenseRestClientInjectionToken: InjectionToken<ILicenseRestClient> = new InjectionToken<ILicenseRestClient>("digital-signage.user-dashboard.dashboard-web.LicenseRestClient");
